module.exports = {"530126001":"鹿阜街道","530126002":"石林街道","530126003":"板桥街道","530126105":"西街口镇","530126106":"长湖镇","530126107":"圭山镇","530126201":"大可乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530126.json
// module id = 2682
// module chunks = 0